/* eslint-disable import/no-unresolved */
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect } from "react";
import SelectBox from "../SelectBox";
import { CityByState } from "../../../slices/InitialDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { FormError } from "../../FormError";
import DatePicker from "react-datepicker";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { setFromData } from "../../../slices/BusinessesSlice";
import { getBusinessFormData, setSelectBoxValue } from "../../../Utils/utils/CommanFnc";
import { useCallback } from "react";
import { AdditionalPlaceBusiness } from "./AdditionalPlaceBusiness";

export function BusinessInformation(props) {
  const dispatch = useDispatch();
  const cityList = useSelector((state) => state.initialData.CitiesList);
  //const loading = useSelector((state) => state.businesses.loading);
  const constitution = props.constitutions;
  const countryZone = props.countryZone;
  const [show, setShow] = useState(false);
  const [cities, setCities] = useState([]);
  //const [placeIndex, setPlaceIndex] = useState(-1);
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState({});
  const [businessLocalData, setBusinessLocalData] = useState({})
  const placeOfBusinessField = {
    address: Yup.string().required("Please enter address"),
    state: Yup.string().required("Please select state"),
    district: Yup.string().required("Please select district"),
    pincode: Yup.string().required("Please enter pincode"),
    email: Yup.string()
      .email("Please enter vaild email")
      .required("Please enter email"),
    contactNo: Yup.string()
      .required("Please enter mobile number")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Please enter valid mobile number"
      ),
  };

  const formSchema = Yup.object().shape({
    businessEntity: Yup.object().shape({
      tradeName: Yup.string().required("Please enter trade name"),
      constitutionBusiness: Yup.string().required(
        "Please choose business constitution"
      ),
      dateOfBooksBeginning: Yup.string().required("Please choose date"),
      //legalname: Yup.string().required("Please enter legal name of business"),
    }),
    businessEntityBranches: Yup.object().shape({
      main: Yup.object().shape(placeOfBusinessField),
      other: Yup.array().of(Yup.object().shape(placeOfBusinessField)),
    }),
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });

  const placeFields = {
    state: "",
    district: "",
    pinCode: "",
    address: "",
    cityList: [],
  };

  let [additionalBusinessPlaces, setAdditionalBusinessPlaces] = useState([]);

  const setBusinessInformation = useCallback(function (localData) {
    const businessEntity = localData?.businessEntity;
    if (businessEntity) {
      localData.businessEntity.dateOfBooksBeginning = localData.businessEntity
        .dateOfBooksBeginning
        ? new Date(localData.businessEntity.dateOfBooksBeginning)
        : "";
      const state = countryZone.find( (country) => country.value.toString() === localData.businessEntityBranches?.main?.state.toString() )
      setSelectedState(state)
      setShow(localData?.businessEntityBranches?.other?.length > 0 ? true : false);
      setValue("businessEntity", localData.businessEntity);
      setValue("businessEntityBranches", localData.businessEntityBranches);
    }
  },[setValue, countryZone])

  useEffect(() => {
    //Set Cities list
    const cityData = cityList.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    // if (placeIndex >= 0) {
    //     setAdditionalBusinessPlaces((prevState)=>{
    //         let newState = Object.assign([],prevState)
    //         newState[placeIndex].cityList = cityData
    //         return newState
    //     })
    // } else {
    setCities(cityData);
    //}
    // if(formData?.businessEntityBranches?.other?.length > 0){
    //   setAdditionalBusinessPlaces(formData?.businessEntityBranches?.other)
    //   setShow(true)
    // }
  }, [cityList]);

  useEffect( () => {
    setBusinessLocalData(getBusinessFormData());
  },[])

  useEffect(() => {
    console.log(businessLocalData)
      setBusinessInformation(businessLocalData);
  }, [businessLocalData, setBusinessInformation]);

  useEffect( () =>{
    if(businessLocalData?.businessEntityBranches?.main?.state){
      dispatch(CityByState(businessLocalData?.businessEntityBranches?.main?.state));
    }
  },[businessLocalData?.businessEntityBranches?.main?.state, dispatch])

  useEffect(()=>{
    if(businessLocalData?.businessEntityBranches?.other){
      setAdditionalBusinessPlaces(businessLocalData?.businessEntityBranches.other)
    }
  },[businessLocalData])

  const addPlace = function () {
    console.log(additionalBusinessPlaces)
    setAdditionalBusinessPlaces( [...additionalBusinessPlaces, placeFields]);
  };

  const removePlace = function (index) {
    let newPlaceValue = [...additionalBusinessPlaces];
    newPlaceValue.splice(index, 1);
    setAdditionalBusinessPlaces(newPlaceValue);
  };

  const changeCountryHandler = function (event, index, fnc) {
    const stateId = event?.value;
    const state = countryZone.find( (country) => country.value === stateId )
    setSelectedState(state)
    setValue("businessEntityBranches.main.district",'');
    let districtToReset = additionalBusinessPlaces?.map((place, index)  => {
        return {
          district:''
        }
    })
    setValue(`businessEntityBranches.other`, districtToReset)
    if (stateId) {
      dispatch(CityByState(stateId));
    }  
    fnc(stateId);
  };

  const showHideAdditionalPlace  = function(event){
    setShow(event.target.checked)
    console.log(placeFields)
    setAdditionalBusinessPlaces((prevState) => {
        console.log([...prevState, placeFields])
        return event.target.checked?[...prevState, placeFields]:[]

    })

  }

  const onSubmit = function (data) {
    dispatch(setFromData(data));
    navigate("/add-business/BusinessNatue");
  }
  return (
    <>
      <div className="col-md-6 col-lg-12">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card payment-card">
            <div className="card-body pt-0">
              <div className="row">
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="tradename"
                      className={`input-label ${
                        errors?.businessEntity?.tradeName && "error"
                      }`}
                    >
                      Trade Name
                    </label>
                    <input
                      {...register("businessEntity.tradeName")}
                      type="text"
                      className={`input-txt form-control ${
                        errors?.businessEntity?.tradeName && "error"
                      }`}
                      placeholder="Trade Name"
                    />
                    {errors?.businessEntity?.tradeName && (
                      <FormError
                        message={errors?.businessEntity?.tradeName?.message}
                      />
                    )}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="constitution"
                      className={`input-label ${
                        errors?.businessEntity?.constitutionBusiness && "error"
                      }`}
                    >
                      Consitution of Business
                    </label>
                    <Controller
                      control={control}
                      name={"businessEntity.constitutionBusiness"}
                      inputValue=""
                      //value={1}
                      // defaultValue={status[0]['value']}
                      render={({ field }) => (
                        <SelectBox
                          className={` ${
                            errors?.businessEntity?.constitutionBusiness &&
                            "error"
                          }`}
                          options={constitution}
                          isClearable={true}
                          onChange={(opt) => field.onChange(opt?.value)}
                          value={setSelectBoxValue(constitution, field.value)}
                        />
                      )}
                    />
                    {errors?.businessEntity?.constitutionBusiness && (
                      <FormError
                        message={
                          errors?.businessEntity?.constitutionBusiness?.message
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="begning" className="input-label">
                      Begning of Books
                    </label>
                    <Controller
                      control={control}
                      name="businessEntity.dateOfBooksBeginning"
                      render={({ field }) => (
                        <DatePicker
                          placeholderText="Select date"
                          className={`input-txt form-control ${
                            errors?.businessEntity?.dateOfBooksBeginning &&
                            "error"
                          }`}
                          dropdownMode="select"
                          //peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          onChange={(date) => field.onChange(date)}
                          selected={field.value}
                          endDate={new Date()}
                        />
                      )}
                    />

                    {errors?.businessEntity?.dateOfBooksBeginning && (
                      <FormError
                        message={
                          errors?.businessEntity?.dateOfBooksBeginning?.message
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card payment-card">
            <div className="card-body pt-0">
              <div className="row">
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      className={`input-label d-block ${
                        errors?.businessEntityBranches?.main?.state?.message &&
                        "error"
                      }`}
                      htmlFor="card-number"
                    >
                      State
                    </label>
                    <Controller
                      control={control}
                      name={"businessEntityBranches.main.state"}
                      // value={status[0]['value']}
                      // defaultValue={status[0]['value']}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          isClearable={true}
                          className={`${
                            errors?.businessEntityBranches?.main?.state &&
                            "error"
                          }`}
                          options={countryZone}
                          onChange={(event) =>
                            changeCountryHandler(event, -1, onChange)
                          }
                          value={setSelectBoxValue(countryZone, value)}
                        />
                      )}
                    />

                    {errors?.businessEntityBranches?.main?.state && (
                      <FormError
                        message={
                          errors?.businessEntityBranches?.main?.state.message
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      className={`input-label d-block ${
                        errors?.businessEntityBranches?.main?.district
                          ?.message && "error"
                      }`}
                      htmlFor="card-number"
                    >
                      District
                    </label>
                    <Controller
                      control={control}
                      // value={status[0]['value']}
                      // defaultValue={status[0]['value']}
                      name={"businessEntityBranches.main.district"}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          isClearable={true}
                          className={` ${
                            errors.businessEntityBranches?.main?.district &&
                            "error"
                          }`}
                          options={cities}
                          onChange={(opt) => onChange(opt?.value?opt?.value:'')}
                          value={setSelectBoxValue(cities, value)}
                        />
                      )}
                    />
                    {errors.businessEntityBranches?.main?.district && (
                      <FormError
                        message={
                          errors.businessEntityBranches?.main?.district.message
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      className={`input-label d-block ${
                        errors.businessEntityBranches?.main?.pincode?.message &&
                        "error"
                      }`}
                      htmlFor="card-number"
                    >
                      PIN Code
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      className={`input-txt form-control ${
                        errors.businessEntityBranches?.main?.pincode && "error"
                      }`}
                      {...register("businessEntityBranches.main.pincode")}
                      placeholder="PIN Code"
                    />
                    {errors.businessEntityBranches?.main?.pincode && (
                      <FormError
                        message={
                          errors.businessEntityBranches?.main?.pincode.message
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="col-4">
                  <div className="col-12 p-0">
                    <div className="form-group mb-3">
                      <label
                        className={`input-label d-block ${
                          errors.businessEntityBranches?.main?.contactNo
                            ?.message && "error"
                        }`}
                        htmlFor="card-number"
                      >
                        Contact
                      </label>
                      <input
                        type="text"
                        {...register("businessEntityBranches.main.contactNo")}
                        placeholder="Contact"
                        className={`input-txt form-control ${
                          errors.businessEntityBranches?.main?.contactNo &&
                          "error"
                        }`}
                      />
                      {errors.businessEntityBranches?.main?.contactNo && (
                        <FormError
                          message={
                            errors.businessEntityBranches?.main?.contactNo
                              .message
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="col-12 p-0">
                    <div className="form-group mb-3">
                      <label htmlFor="card-number" className="d-block">
                        Email
                      </label>
                      <input
                        type="text"
                        {...register("businessEntityBranches.main.email")}
                        placeholder="Email"
                        className={`input-txt form-control ${
                          errors.businessEntityBranches?.main?.email && "error"
                        }`}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label
                      className={`input-label d-block ${
                        errors.businessEntityBranches?.main?.address?.message &&
                        "error"
                      }`}
                      htmlFor="card-number"
                    >
                      Address
                    </label>
                    <textarea
                      rows="5"
                      defaultValue=""
                      {...register("businessEntityBranches.main.address")}
                      placeholder="Address"
                      className={`form-control text-box ${
                        errors.businessEntityBranches?.main?.contactNo &&
                        "error"
                      }`}
                    />
                    {errors.businessEntityBranches?.main?.address && (
                      <FormError
                        message={
                          errors.businessEntityBranches?.main?.address.message
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="col-4" style={{maxWidth:"30%"}}>
                  <div className="form-group d-block mb-3 additionalBusiness">
                    <label htmlFor="card-number" className="additionalBusiness">
                      <input
                        width=""
                        type="checkbox"
                        id="card-number"
                        {...register("businessEntityBranches.isAdditonal")}
                        checked={show}
                        onClick={(e) => showHideAdditionalPlace(e)}
                        placeholder="Do you have Additional Place of Business"
                        className="additionalBusiness-input"
                      />
                      Do you have Additional Place of Business
                    </label>
                  </div>
                </div>
                {
                  show?
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header addAdditionalBusiness pb-0">
                        <h4>ADDITIONAL PLACE BUSINESS</h4>
                        <button
                          onClick={() => addPlace()}
                          type="button"
                          className="btn btn-info"
                        >
                          Add More
                        </button>
                      </div>
                      <hr />
                      {
                        additionalBusinessPlaces?.map((item, key) => {
                          let placeText = "Place " + parseInt(key + 1)
                          return (
                            <AdditionalPlaceBusiness 
                              errors={errors}
                              zoneName={selectedState}
                              control={control} 
                              changeCountryHandler={changeCountryHandler} 
                              register={register} 
                              itemKey={key} 
                              key={key} 
                              item={item}
                              removePlace={removePlace}
                              placeText={placeText}
                              setValue={setValue}
                            />
                          )
                        })
                      }
                      
                    </div>
                  </div>:''
                }
              </div>
            </div>
            <div className="col-12 mb-3 text-right">           
              <button type="button" onClick={(e)=>{ navigate('/manage-business') }} className="btn btn-danger btn-lg px-5">
                Cancel
              </button>
              &nbsp;
              <button type="submit" className="btn btn-success btn-lg px-5">
                Next
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
